/* force-consistent brand breadcrumbs on vendor query pages */
(function () {
  const currentPath = window.location.pathname.toLowerCase();
  const currentQuery = new URLSearchParams(window.location.search);
  const vendorQuery = (currentQuery.get("q") || "").trim();

  if (currentPath === "/collections/vendors" && vendorQuery.toLowerCase() === "rvca") {
    window.location.replace("/collections/rvca");
    return;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getBrandName() {
    const heading = document.querySelector("main h1, .collection-banner h1, h1");
    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }
    return vendorQuery.replace(/-/g, " ");
  }

  function fixVendorQueryBreadcrumb() {
    if (!document.body.classList.contains("template-collection")) return;
    if (currentPath !== "/collections/vendors" || !vendorQuery) return;

    const navs = document.querySelectorAll("nav[aria-label='breadcrumbs']");
    navs.forEach(function (nav) {
      if (nav.getAttribute("data-brand-breadcrumb-fixed") === "1") return;
      const homeLink = nav.querySelector("a");
      if (!homeLink) return;

      const brandName = getBrandName();
      nav.innerHTML =
        homeLink.outerHTML +
        '<i>/</i><a href="/pages/brands" title="Brand">Brand</a>' +
        "<i>/</i>" +
        escapeHtml(brandName);
      nav.setAttribute("data-brand-breadcrumb-fixed", "1");
    });
  }

  document.addEventListener("DOMContentLoaded", fixVendorQueryBreadcrumb);
  document.addEventListener("shopify:section:load", fixVendorQueryBreadcrumb);
  window.addEventListener("pageshow", fixVendorQueryBreadcrumb);
  setTimeout(fixVendorQueryBreadcrumb, 400);
})();


/*

function markSoldOutOptions() {
  console.log('checking options');

  const radioEls = document.querySelectorAll('input[name="Size"]');

  radioEls.forEach(radioEl => {
    if (radioEl.checked && radioEl.classList.contains("is-disabled")) {
      radioEl.setAttribute('checked', false);
      const firstAvailableRadio = Array.from(radioEls).find(input => 
        !input.classList.contains('is-disabled')
      );

      if (firstAvailableRadio) {
        firstAvailableRadio.setAttribute('checked', true);
      }

    }
  });
  
  // add sold out text to select options
  document.querySelectorAll('fieldset[data-handle="size"] option').forEach(optEl => {
    const soldOutText = ' (Sold out)';
    
    if (optEl.disabled) {
      // Add the label if missing
      if (!optEl.textContent.includes(soldOutText)) {
        optEl.textContent += soldOutText;
      }
    } else {
      // Remove the label if present
      if (optEl.textContent.includes(soldOutText)) {
        optEl.textContent = optEl.textContent.replace(soldOutText, '');
      }
    }
  });

}

// 1. Run it on page load
markSoldOutOptions();
*/

/* restore collection/search position near last viewed product when using browser back */
(function () {
  const STORAGE_KEY = "ts:last-grid-product-nav";
  const body = document.body;
  const isGridTemplate =
    body.classList.contains("template-collection") ||
    body.classList.contains("template-search");
  let suppressAutoRestore = false;
  let restoreStarted = false;
  let restoreFinished = false;

  function extractProductHandle(urlLike) {
    try {
      const u = new URL(urlLike, window.location.origin);
      const m = u.pathname.match(/\/products\/([^\/?#]+)/i);
      return m ? m[1] : "";
    } catch (e) {
      return "";
    }
  }

  function parseHandleFromHash() {
    const raw = (window.location.hash || "").trim();
    const m = raw.match(/^#p-([a-z0-9][a-z0-9-]*)$/i);
    return m ? m[1].toLowerCase() : "";
  }

  function stampCurrentHistoryWithHandle(handle) {
    if (!handle) return;
    try {
      const url = new URL(window.location.href);
      url.hash = "p-" + handle;
      window.history.replaceState(window.history.state, document.title, url.toString());
    } catch (e) {
      // no-op
    }
  }

  function getNavType() {
    const entries = performance.getEntriesByType && performance.getEntriesByType("navigation");
    if (entries && entries.length) return entries[0].type;
    return "";
  }

  function saveGridNavigationState(targetEl, productUrl) {
    const card = targetEl.closest("li.column, product-card, .product-card");
    if (!card) return;
    const cards = Array.from(document.querySelectorAll("#product-grid > li.column"));
    const cardIndex = cards.indexOf(card.closest("li.column"));
    const params = new URLSearchParams(window.location.search);
    const payload = {
      sourcePath: window.location.pathname + window.location.search,
      sourcePathname: window.location.pathname,
      sourceSearchQ: (params.get("q") || "").trim().toLowerCase(),
      productHandle: extractProductHandle(productUrl),
      cardIndex: cardIndex >= 0 ? cardIndex : null,
      clickScrollY: Math.max(0, Math.round(window.scrollY || 0)),
      fallbackY: Math.max(
        0,
        Math.round(card.getBoundingClientRect().top + window.scrollY - 120)
      ),
      ts: Date.now(),
    };
    if (!payload.productHandle) return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  }

  function restoreNearLastViewedProduct() {
    if (restoreFinished || restoreStarted) return;

    const hashHandle = parseHandleFromHash();
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw && !hashHandle) return;

    let state = null;
    if (raw) {
      try {
        state = JSON.parse(raw);
      } catch (e) {
        state = null;
      }
    }
    if (!state && !hashHandle) return;

    const currentPath = window.location.pathname + window.location.search;
    const currentPathname = window.location.pathname;
    const currentParams = new URLSearchParams(window.location.search);
    const currentSearchQ = (currentParams.get("q") || "").trim().toLowerCase();
    const activeHandle =
      hashHandle || (state && state.productHandle ? String(state.productHandle).toLowerCase() : "");
    if (!activeHandle) return;

    // Match by pathname (more robust for filter/sort querystring reordering on back nav).
    if (state && state.sourcePathname && state.sourcePathname !== currentPathname) return;
    // On search pages, keep query-bound restoration strict.
    if (state && body.classList.contains("template-search") && state.sourceSearchQ !== currentSearchQ)
      return;
    if (state && Date.now() - Number(state.ts || 0) > 1000 * 60 * 60 * 4) return;

    // Deep restore controller: hydrate enough grid rows first, then do one final scroll.
    const desiredY =
      state && typeof state.fallbackY === "number" && state.fallbackY > 0 ? state.fallbackY : null;
    const clickScrollY =
      state && typeof state.clickScrollY === "number" && state.clickScrollY >= 0
        ? state.clickScrollY
        : null;
    const desiredIndex =
      state && Number.isInteger(state.cardIndex) && state.cardIndex >= 0 ? state.cardIndex : null;
    let hardFallbackY = desiredY !== null ? desiredY : clickScrollY;
    if (hardFallbackY === null) hardFallbackY = 0;

    function forceScrollRestore(y, stopIfUserScrolls) {
      if (suppressAutoRestore) return;
      const current = window.scrollY || 0;
      const drift = Math.abs(current - y);
      if (stopIfUserScrolls && drift > 260) return;
      window.scrollTo({ top: y, behavior: "auto" });
    }

    function getPaginationEl() {
      return document.querySelector(
        "pagination-theme.pagination-type--infinite, pagination-theme.pagination-type--loadmore"
      );
    }

    function tryLoadMoreResults(paginationEl) {
      if (!paginationEl) return false;
      if (paginationEl.getAttribute("loading")) return false;
      if (typeof paginationEl.loadProducts !== "function") return false;
      paginationEl.loadProducts();
      return true;
    }

    function getDocHeight() {
      return Math.max(document.body.scrollHeight || 0, document.documentElement.scrollHeight || 0);
    }

    function getCardsCount() {
      return document.querySelectorAll("#product-grid > li.column").length;
    }

    function waitForHydration(paginationEl, timeoutMs) {
      return new Promise(function (resolve) {
        let done = false;
        let timer = null;
        let mo = null;
        const grid = document.getElementById("product-grid");

        function finish() {
          if (done) return;
          done = true;
          if (timer) window.clearTimeout(timer);
          if (mo) mo.disconnect();
          resolve();
        }

        timer = window.setTimeout(finish, timeoutMs);
        if (grid && "MutationObserver" in window) {
          mo = new MutationObserver(function () {
            finish();
          });
          mo.observe(grid, { childList: true, subtree: true });
        }

        if (paginationEl && !paginationEl.getAttribute("loading")) {
          finish();
        }
      });
    }

    function waitForPaginationReady(timeoutMs) {
      return new Promise(function (resolve) {
        const start = Date.now();
        function check() {
          const el = getPaginationEl();
          if (el && typeof el.loadProducts === "function") {
            resolve(el);
            return;
          }
          if (Date.now() - start >= timeoutMs) {
            resolve(el || null);
            return;
          }
          window.setTimeout(check, 80);
        }
        check();
      });
    }

    function findHandleAnchor() {
      return document.querySelector('#product-grid a[href*="/products/' + activeHandle + '"]');
    }

    function needsMoreContent() {
      const cardsNow = getCardsCount();
      const docHeight = getDocHeight();
      const needMoreCards = desiredIndex !== null && cardsNow <= desiredIndex;
      const needMoreHeight = desiredY !== null && docHeight < desiredY + window.innerHeight * 0.35;
      const needByHandle = !findHandleAnchor();
      return needMoreCards || needMoreHeight || needByHandle;
    }

    function restoreToBestTarget() {
      const target = findHandleAnchor();
      if (target) {
        if (desiredY !== null) {
          forceScrollRestore(desiredY, false);
        } else {
          const y = Math.max(
            0,
            Math.round(target.getBoundingClientRect().top + window.scrollY - 120)
          );
          forceScrollRestore(y, false);
        }
        suppressAutoRestore = true;
        return;
      }

      if (desiredIndex !== null) {
        const cards = document.querySelectorAll("#product-grid > li.column");
        if (cards.length > desiredIndex) {
          const card = cards[desiredIndex];
          if (card) {
            const y = Math.max(0, Math.round(card.getBoundingClientRect().top + window.scrollY - 120));
            forceScrollRestore(y, false);
            suppressAutoRestore = true;
            return;
          }
        }
      }
      forceScrollRestore(hardFallbackY, false);
    }

    async function startRestoreController() {
      // If we landed on a very similar URL (same path, query drift), update state path snapshot.
      if (state && state.sourcePath !== currentPath) {
        state.sourcePath = currentPath;
        state.sourcePathname = currentPathname;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      }

      const initialMaxScroll = Math.max(0, getDocHeight() - window.innerHeight);
      if (desiredY !== null && desiredY > initialMaxScroll + 64) {
        // Keep user near bottom of currently-loaded content while we hydrate deeper pages.
        const holdY = Math.max(0, initialMaxScroll - 220);
        forceScrollRestore(holdY, false);
      } else {
        forceScrollRestore(hardFallbackY, false);
      }

      const initialCards = Math.max(1, getCardsCount());
      const expectedLoadsByIndex =
        desiredIndex !== null ? Math.ceil((desiredIndex + 1) / initialCards) + 4 : 40;
      const maxLoadCalls = Math.min(80, Math.max(20, expectedLoadsByIndex));

      let loads = 0;
      while (loads < maxLoadCalls && needsMoreContent()) {
        let paginationEl = getPaginationEl();
        if (!paginationEl || typeof paginationEl.loadProducts !== "function") {
          paginationEl = await waitForPaginationReady(2000);
        }
        if (!paginationEl || typeof paginationEl.loadProducts !== "function") {
          break;
        }
        if (!paginationEl.getAttribute("loading")) {
          const didStart = tryLoadMoreResults(paginationEl);
          if (!didStart) break;
          loads += 1;
        }
        await waitForHydration(paginationEl, 1600);
        // Allow appended cards to settle before checking again.
        await new Promise(function (resolve) {
          window.setTimeout(resolve, 80);
        });
      }
      restoreToBestTarget();
      restoreFinished = true;
    }
    restoreStarted = true;
    startRestoreController();
  }

  if (isGridTemplate) {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    function captureProductNavTarget(event) {
      const anchor = event.target.closest('#product-grid a[href*="/products/"]');
      if (anchor && anchor.href) {
        const handle = extractProductHandle(anchor.href);
        stampCurrentHistoryWithHandle(handle);
        saveGridNavigationState(anchor, anchor.href);
        return true;
      }

      const linkedTarget = event.target.closest('#product-grid [data-href*="/products/"]');
      if (linkedTarget) {
        const productUrl = linkedTarget.getAttribute("data-href") || "";
        if (!productUrl) return false;
        const handle = extractProductHandle(productUrl);
        stampCurrentHistoryWithHandle(handle);
        saveGridNavigationState(linkedTarget, productUrl);
        return true;
      }
      return false;
    }

    document.addEventListener(
      "pointerdown",
      function (event) {
        captureProductNavTarget(event);
      },
      true
    );
    document.addEventListener(
      "click",
      function (event) {
        captureProductNavTarget(event);
      },
      true
    );

    const navType = getNavType();
    // Fresh collection links, including PDP breadcrumbs, start at the top.
    // Only history navigation or an explicit saved-product anchor restores a row.
    if (navType === "back_forward" || parseHandleFromHash()) {
      restoreNearLastViewedProduct();
    }
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted || getNavType() === "back_forward" || parseHandleFromHash()) {
        restoreNearLastViewedProduct();
      }
    });
    window.addEventListener("popstate", function () {
      restoreNearLastViewedProduct();
    });
  }
})();
